const appointmentEnumerators = {
  appointmentStatus: [
    'pending',
    'confirmed',
    'canceled',
    'absent',
  ],
  paymentStatus: [
    'paid',
    'payment_pending',
    'pay_there',
  ],
}

export default appointmentEnumerators
